// extracted by mini-css-extract-plugin
export default {"Footer":"DetailsFooter_Footer__EiTnv"};